import {
  WorkflowTemplatesFilterPanel,
  WorkflowTemplatesTablePanel,
} from "#src/batteries-included-components";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { Page } from "@validereinc/common-components";
import React from "react";
import { WorkflowTemplatesRoutePath } from ".";

export const WorkflowTemplatesPage = () => {
  const [filterConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-configuration", "table-state"],
      ["workflows", "templates", "list"]
    );
  const [breadcrumbs] = useBreadcrumbsFromRoute(WorkflowTemplatesRoutePath);

  return (
    <Page
      title={WorkflowTemplatesRoutePath.title}
      category={WorkflowTemplatesRoutePath.subtitle}
      breadcrumbs={breadcrumbs}
    >
      <WorkflowTemplatesFilterPanel
        showCategoryFilter={true}
        filterConfigStorageKey={filterConfigStorageKey}
      />
      <WorkflowTemplatesTablePanel
        filterConfigStorageKey={filterConfigStorageKey}
        tableConfigStorageKey={tableConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
      />
    </Page>
  );
};
